import * as React from 'react';
import styled from 'styled-components';
import { colorsV2 } from '../colors-v2';
import cl from 'classnames';

const Container = styled.div`
  padding: 1px;
  border-radius: 15px;
  border: 1px solid ${colorsV2.neutral40};
  background: ${colorsV2.white100};
  cursor: pointer;

  &:hover {
    border: 1px solid ${colorsV2.neutral140};
  }

  &.selected {
    border: 1px solid ${colorsV2.blue20};

    &:hover {
      border: 1px solid ${colorsV2.blue60};
    }
  }
`;

const Cirle = styled.div`
  display: flex;
  width: 16px;
  height: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  background: ${colorsV2.white100};

  &.selected {
    background: ${colorsV2.blue100};
  }
`;

export interface QuestionRadioProps {
  selected?: boolean;
}

export const QuestionRadio = (props: QuestionRadioProps) => {
  const { selected } = props;

  return (
    <Container className={cl('question-radio', { selected })}>
      <Cirle className={cl({ selected })} />
    </Container>
  );
};
